export default "__VITE_ASSET__CNC_H0m$__"